// components/Button.js
import '../styles/Button.css';

const Button = ({ children, onClick, type = "button" }) => {
  return (
    <button type={type} className="custom-button" onClick={onClick}>
      {children}
    </button>
  );
};

export default Button;